export interface VencimentoFiltro {
  label: string;
  value: string;
}

export const vencimentoFiltroOptions: VencimentoFiltro[] = [
  { label: 'Hoje', value: 'hoje' },
  { label: 'Esta semana', value: 'semana' },
  { label: 'Este mês', value: 'mes' },
  { label: 'Este ano', value: 'ano' },
  { label: 'Últimos 30 dias', value: 'ultimos_30' },
  { label: 'Últimos 12 meses', value: 'ultimos_12' },
  { label: 'Todo o período', value: 'todos' },
  { label: 'Período personalizado', value: 'personalizado' },
];


export interface FiltrosDespesas {
  vencimento?: string; 
  dsDespesa?: string;
  contaId?: number;
  dataVencimento?: string;
}
